var exports = {};
exports = function findRootNode(element) {
  while (element.parentNode) {
    element = element.parentNode;
  }
  return element;
};
export default exports;